import axios from 'axios';
import { saveAs } from 'file-saver';
import moment from 'moment';

export const getMonitoringListApi = async ({ customerId }) => {
  const response = await axios.get(`admin/customer/${customerId}/monitoring`);
  return response.data;
};

export const getMonitoringApi = async ({ customerId, monitoringId }) => {
  const response = await axios.get(
    `admin/customer/${customerId}/monitoring/${monitoringId}`
  );
  return response.data;
};

export const fetchMonitoringApi = async ({ customerId, data = {} }) => {
  const response = await axios.post(
    `admin/customer/${customerId}/monitoring/fetch`,
    data,
    { timeout: 180000 }
  );
  return response.data;
};

export const buildMonitoringSlidesApi = async ({ customerId, payload }) => {
  const response = await axios.post(
    `admin/customer/${customerId}/monitoring/slides/build`,
    { payload },
    { timeout: 180000 }
  );
  return response.data;
};

export const downloadMonitoringSlidesApi = async ({
  customerId,
  monitoringId,
  slidesSnapshot,
}) => {
  const response = await axios.post(
    `admin/customer/${customerId}/monitoring/slides/download`,
    monitoringId ? { monitoringId } : { slidesSnapshot },
    { timeout: 120000 }
  );
  return response.data;
};

export const saveMonitoringApi = async ({ customerId, data }) => {
  const response = await axios.post(
    `admin/customer/${customerId}/monitoring/save`,
    data
  );
  return response.data;
};

export const deleteMonitoringApi = async ({ customerId, monitoringId }) => {
  await axios.delete(
    `admin/customer/${customerId}/monitoring/${monitoringId}`
  );
};

export const downloadPortfolioMonitoringExcelApi = async ({ asOfDate } = {}) => {
  const response = await axios.post(
    'admin/monitoring/portfolio-excel',
    asOfDate ? { asOfDate } : {},
    {
      responseType: 'blob',
      timeout: 300000,
    }
  );
  const dateLabel = asOfDate || moment().format('YYYY-MM-DD');
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, `portfolio-monitoring-${dateLabel}.xlsx`);
};
